import API from 'API';

export const getStepLevels = async () => API.find('stepLevels/');

export const getStepTypes = async () => API.find('stepTypes/');

export const getBadges = async () => API.find('badges/');

export const saveStepMedia = async (id, media) =>
  API.saveMedia(`steps/${id}/media`, media);

export const saveStep = async (step, sbs) => API.save('steps/', {...step, sbs});

export const deleteStep = async (step) => API.delete('steps/', step);

export const saveAllStepConsumables = async (stepConsumables) =>
  API.save('stepConsumables/saveAll', stepConsumables);

export const saveStepConsumable = async (stepConsumable) =>
  API.save('stepConsumables/', stepConsumable);

export const deleteStepConsumable = async (stepConsumable) =>
  API.delete('stepConsumables/', stepConsumable);

export const findStepById = async (stepId) => API.find(`steps/${stepId}`);

export const saveStepLists = async (duplicationSelectedSteps) =>
  API.save('stepLists/', duplicationSelectedSteps);

export const findStepsBySbs = (id, startStepId) =>
  API.find(`sbss/${id}/steps`, startStepId && {stepId: startStepId});

export const saveStepAfter = async (id, previousStepId, decision) =>
  API.rpc(`steps/${id}/addStepAfter`, {
    ...(previousStepId && {previousStepId}),
    decision: decision === 0 ? 0 : 1,
  });
